import { render, staticRenderFns } from "./AmazonProductComponent.vue?vue&type=template&id=72257c65&scoped=true&"
import script from "./AmazonProductComponent.vue?vue&type=script&lang=js&"
export * from "./AmazonProductComponent.vue?vue&type=script&lang=js&"
import style0 from "./AmazonProductComponent.vue?vue&type=style&index=0&id=72257c65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72257c65",
  null
  
)

export default component.exports